export default __webpack_public_path__ + "static/multi-ai-1579fe25fef7e9c53ecd0467bb0e5a9cb32079759301dc9ba2b1b553ac5d1f68.png";